<template>
  <el-form-item :prop="field" :rules="rules" size="small">
    <span slot="label">
      <span class="form-item__label">{{ label }}</span>
      <span class="form-item__tip" v-if="tip">({{ tip }})</span>
    </span>
    <app-img-uploader2 :image="value | showImage" @change="handleChange" size="small"></app-img-uploader2>
  </el-form-item>
</template>

<script>
import AppImgUploader2 from '@/components/AppImgUploader2'

export default {
  name: 'app-type-image',
  components: {
    AppImgUploader2
  },
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    field: {
      type: String
    },
    tip: {
      type: String,
      default: ''
    },
    rules: {
      type: [ Object, Array ]
    },
    value: {
      type: [ String, Number ],
      default: ''
    },
    placeholder: {
      type: String,
      default: '请在此输入内容'
    }
  },

  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false
    }
  },

  methods: {
    handleChange ($event) {
      this.$emit('input', $event)
    }
  }
}
</script>

<style lang="scss">
.disable-upload {
  .el-upload--picture-card {
    display: none;
  }
}
.el-tag {
  em {
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 200px;
    overflow: hidden;
    font-style: normal;
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
